module.exports = __webpack_public_path__ + "img/xcg5.9b1fd93d.png";